//@flow
import * as React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

import { useGlobalState } from '../store'

import type { GlobalState } from '../types/globalState'

type HeadTitleProps = {
  title?: string,
  subtitle?: any,
}

const useHeadTitleStyle = makeStyles({
  title: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 900,
    marginTop: 16,
    marginBottom: 16,
  },
  subtitle: (theme) => ({
    textAlign: 'center',
    fontSize: 15,
  }),
})
const HeadTitle: React.ComponentType<HeadTitleProps> = ({ title, subtitle = '' }) => {
  const [theme]: GlobalState = useGlobalState('theme')
  const classes = useHeadTitleStyle(theme)

  return (
    <div>
      <Typography className={classes.title} variant="h2">
        {title}
      </Typography>
      {!!subtitle && (
        <Typography variant="subtitle1" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
    </div>
  )
}
export default HeadTitle
